<template>
  <div>
    <module-card :title="'活动: ' + info.activityId + '  ' + info.activityName">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="商户详情" name="merchantDetails">
          <div class="title-bold">商户信息</div>
          <el-form :model="merchantDetailsForm" ref="merchantDetailsForm" label-width="100px" label-position="left" :rules="merchantDetailsRules" :disabled="!isEditMerchantDetails">
            <el-form-item label="商户编号" prop="merchantId">
              <el-input v-model="merchantDetailsForm.merchantId" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入商户编号" class="form-input" disabled clearable></el-input>
            </el-form-item>
            <el-form-item label="门店名称" prop="shopName">
              <el-input v-model="merchantDetailsForm.shopName" placeholder="请输入门店名称" disabled class="form-input" clearable></el-input>
            </el-form-item>
            <el-form-item label="经营地址" :required="true">
               <address-select ref="addressForm" v-model="merchantDetailsForm.address" :require="true"  :readOnly="!isEditMerchantDetails"  @getValue="getAddress"></address-select>
            </el-form-item>
            <el-form-item label="结算人" prop="settleName" v-if="parseInt(info.optType) !== 10">
              <el-input v-model="merchantDetailsForm.settleName" placeholder="请输入结算人姓名" class="form-input" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号"  v-if="parseInt(info.optType) !== 10">
              <el-radio-group v-model="merchantDetailsForm.mobileType">
                <el-radio :label="0">默认手机号</el-radio>
                <el-radio :label="1">使用新手机号</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="" prop="mobile" v-if="merchantDetailsForm.mobileType===1 && parseInt(info.optType) !== 10">
              <el-input v-model="merchantDetailsForm.mobile" placeholder="请输手机号" class="form-input" clearable></el-input>
            </el-form-item>
            <el-form-item label="拓展来源" prop="extendedSource">
              <el-radio-group v-model="merchantDetailsForm.extendedSource" clearable placeholder="请选择拓展来源">
                <el-radio v-for="item in extendedSourceList" :key="item.value" :label="item.value">{{item.text}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="添加来源" prop="source">
              <div>{{merchantDetailsForm.source===10?"后台录入":'小程序添加'}}</div>
            </el-form-item>
            <el-form-item label="活动参与状态">{{joinState===0?'正常':'已退出'}}</el-form-item>
            <el-form-item label="活动退出时间" v-if="joinState">{{exitTime}}</el-form-item>
          </el-form>
          <el-row type="flex" justify="center" v-if="joinState===0&&(![0,40].includes(openCardStatus))">
            <auth-button opt="edit_merchant_details" type="warning" v-if="!isEditMerchantDetails"  label="修改资料" @click.native="editMerchantDetails"></auth-button>
            <el-button type=primary v-if="isEditMerchantDetails" @click="confirmUpdateMerchantDetails">确定</el-button>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="开卡信息" name="openCardInfo">
           <div class="title-bold">开卡信息</div>
           <el-form :model="openCardInfoForm" ref="openCardInfoForm" label-width="130px" label-position="left" :disabled="!isEditOpenCardInfo">
             <el-form-item label="是否需要开卡" prop="optType">
               <el-radio-group v-model="openCardInfoForm.optType" clearable placeholder="请选择拓展来源" :disabled="openCardInfoForm.status===40">
                <el-radio v-for="item in optTypeMap" :key="item.value" :label="item.value">{{item.text}}</el-radio>
              </el-radio-group>
             </el-form-item>
             <el-form-item label="开卡状态" prop="status">
                <el-select v-model="openCardInfoForm.status" class="form-input" :disabled="openCardInfoForm.status===0||openCardInfoForm.status===40">
                  <el-option v-for="item in statusList" :key="item.value" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
             <el-form-item label="银行网点" prop="cardBankNewId">
                <el-select v-model="openCardInfoForm.cardBankNewId" class="form-input" clearable placeholder="请选择上门开卡的银行网点" :disabled="openCardInfoForm.status===40" @change="handleBankChange" ref="cardBankNewId" >
                  <el-option
                    v-for="item in bankList"
                    :key="item.bankNewId"
                    :label="item.bankName"
                    :value="item.bankNewId">
                  </el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="网点银行经理" prop="managerId">
                <el-select v-model="openCardInfoForm.managerId" class="form-input" clearable placeholder="请选择银行网点客户经理" :disabled="openCardInfoForm.status===40">
                  <el-option
                    v-for="item in managerList"
                    :key="item.managerId"
                    :label="item.name"
                    :value="item.managerId">
                  </el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="银行备注" prop="bankRemark" v-if="openCardInfoForm.optType!==10">
               <el-input type="textarea" v-model="openCardInfoForm.bankRemark" class="form-input" :rows="3" :disabled="openCardInfoForm.status===40"></el-input>
             </el-form-item>
             <el-form-item label="推广员开卡备注" prop="remark">
                <el-input type="textarea" v-model="openCardInfoForm.remark" class="form-input" :rows="3"></el-input>
             </el-form-item>
             <el-form-item label="录入时间" prop="createTime">
                <div>{{openCardInfoForm.createTime}}</div>
             </el-form-item>
             <el-form-item label="录入人" prop="keyboarder">
                <div>{{openCardInfoForm.keyboarder}}</div>
             </el-form-item>
             <el-form-item label="开卡推广员" prop="marketerName">
               <div>{{openCardInfoForm.marketerName}}</div>
             </el-form-item>
             <el-form-item label="系统校验绑卡时间" prop="accountBindTime">
               <div>{{openCardInfoForm.accountBindTime}}</div>
             </el-form-item>
             <el-form-item label="银行卡号" prop="settleBankAccount" v-if="openCardInfoForm.optType!==10">
               <el-input v-model="openCardInfoForm.settleBankAccount" placeholder="请输入银行卡号" class="form-input" disabled></el-input>
             </el-form-item>
             <el-form-item label="补贴对象" prop="settleType">
                <el-radio-group v-model="openCardInfoForm.settleType" :disabled="!([0,1,2,9].includes($store.state.userInfo.userType) && info.activityType==10)">
                  <el-radio :label="10">补贴给代理商</el-radio>
                  <el-radio :label="0">补贴给商户</el-radio>
                </el-radio-group>
             </el-form-item>
           </el-form>
           <el-row type="flex" justify="center" v-if="canUpdateOpenCardInfo">
              <auth-button opt="edit_merchant_details" type="warning" v-if="!isEditOpenCardInfo"  label="修改" @click.native="editOpenCardInfo"></auth-button>
              <el-button type=primary v-if="isEditOpenCardInfo" @click="confirmUpdateOpenCard">确定</el-button>
           </el-row>
        </el-tab-pane>
        <el-tab-pane label="绑卡记录" name="bindCardRecords">
          <el-table border :data="bindHistoryData">
            <el-table-column label="绑卡时间" prop="bindTime">
              <template slot-scope="{row}">
                <span>{{ row.bindTime === '1990-01-01 00:00:00' && row.newCardStatus !== 40 ? '-' : row.bindTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="银行卡号" prop="newBankCard"></el-table-column>
            <el-table-column label="银行网点" prop="bankSite"></el-table-column>
            <el-table-column label="状态" prop="newCardStatus">
               <template slot-scope="scope">{{getStatusText(scope.row.newCardStatus)}}</template>
            </el-table-column>
          </el-table>
          <pagination
            :count="bindPagination.total"
            :page-no="bindPagination.pageNo"
            :size="bindPagination.pageSize"
            @changePage="value => { bindPagination.pageNo = value;getBindRecordList() }"
            @changeSize="value => { bindPagination.pageSize = value;bindPagination.pageNo = 1;getBindRecordList() }"
           ></pagination>
        </el-tab-pane>
        <el-tab-pane label="操作记录" name="operateRecords">
          <el-table border :data="operateRecordsPageData">
            <el-table-column label="序号" type="index" width="100px"></el-table-column>
            <el-table-column label="时间" prop="createTime"></el-table-column>
            <el-table-column label="操作人" prop="operatorId"></el-table-column>
            <el-table-column label="操作内容" prop="operationContent"></el-table-column>
          </el-table>
          <pagination
            :count="operatePagination.total"
            :page-no="operatePagination.pageNo"
            :size="operatePagination.pageSize"
            @changePage="value => { operatePagination.pageNo = value;setRecordsDataByPage() }"
            @changeSize="value => { operatePagination.pageSize = value;operatePagination.pageNo = 1;setRecordsDataByPage() }"
           ></pagination>
        </el-tab-pane>
      </el-tabs>
    </module-card>
  </div>
</template>

<script>
import addressSelect from '@/components/addressSelect'
import pagination from '@/components/pagination'
export default {
  name: 'MerchantInfo',
  components: { addressSelect, pagination },

  data () {
    return {
      info: {
        activityId: '',
        activityName: '',
        optType: '',
        activityType: ''
      },
      isFirstClicked: false,
      isSecondClicked: false,
      isThirdClicked: false,
      isForthClicked: false,
      isEditMerchantDetails: false,
      isEditOpenCardInfo: false,
      activeName: 'merchantDetails',
      extendedSourceList: [
        {
          text: '银行推荐',
          value: 10
        }, {
          text: '其他',
          value: 0
        }
      ],
      statusList: [{
        text: '未预约',
        value: 10
      }, {
        text: '已指派',
        value: 50
      }, {
        text: '已预约',
        value: 20
      }, {
        text: '已开卡',
        value: 30
      }, {
        text: '已绑卡',
        value: 40
      }, {
        text: '无效',
        value: 0
      }],
      optTypeMap: [
        {
          text: '否',
          value: 10
        }, {
          text: '是',
          value: 0
        }
      ],
      merchantDetailsForm: {
        merchantId: '',
        shopName: '',
        address: {
          address: '',
          provinceName: '',
          provinceNo: '',
          cityName: '',
          cityNo: '',
          areaName: '',
          areaNo: ''
        },
        accountBindTime: '', // 系统校验绑卡时间
        settleName: '',
        mobile: '',
        mobileType: '', // 0 =默认手机号，1=新增手机号
        extendedSource: 10, // 扩展来源—0其他，10银行推荐
        source: '' // 来源0=小程序添加 10=后台录入
      },
      merchantDetailsRules: {
        merchantId: [
          { required: true, message: '请输入商户编号', trigger: 'blur' }
        ],
        shopName: [
          { required: true, message: '请输入门店名称', trigger: 'blur' }
        ],
        settleName: [
          { required: true, message: '请输入结算人姓名', trigger: 'blur' }
        ],
        mobile: [{
          validator: (rule, value, callback) => {
            if (!(/\*|^\d{11,11}$/.test(value))) {
              callback(new Error('请输入11位手机号码'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }]
      },
      openCardInfoForm: {
        optType: 0, // 0=需要上门开卡， 10=不需上门开卡 30-网点开卡
        status: '', // 开卡状态 0=无效，10=未预约，20=已预约，30=已开卡，40=已绑卡
        cardBankNewId: '', // 银行网点
        managerId: '', // 网点银行经理
        createTime: '', // 录入时间
        keyboarder: '', // 录入人
        accountBindTime: '', // 系统校验绑卡时间
        bankRemark: '', // 银行备注
        remark: '', // 开卡推广员备注
        marketerName: '', // 开卡推广员
        settleBankAccount: '', // 银行卡号
        settleType: '' // 补贴对象 0商户 10代理商
      },
      bankList: [],
      managerList: [],
      bindPagination: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      bindHistoryData: [],
      operateRecordsData: [], // 操作记录所有数据
      operateRecordsPageData: [], // 操作记录当前页的数据
      operatePagination: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      joinState: null,
      exitTime: null,
      openCardStatus: ''
    }
  },

  computed: {
    canUpdateOpenCardInfo () {
      let flag = true
      if (this.joinState === 0) {
        if (this.openCardStatus) {
          flag = true
          // if (this.openCardStatus === 40) {
          //   flag = this.info.activityType === 10
          // } else {
          //   flag = true
          // }
        } else {
          flag = false
        }
      } else {
        flag = false
      }
      return flag
    }
  },

  created () {
    this.info.activityId = this.$route.query.activityId
    this.info.activityName = this.$route.query.activityName
    this.info.optType = this.$route.query.optType
    this.info.activityType = this.$route.query.activityType
    this.joinState = Number(this.$route.query.joinState)
    this.exitTime = this.$route.query.exitTime
    this.openCardStatus = Number(this.$route.query.openCardStatus)
    this.isFirstClicked = true
    this.getMerchantDetails()
    this.getBankByActivityId()
  },

  mounted () {},

  methods: {
    getStatusText (activityStatus) {
      const result = this.statusList.filter(item => {
        return item.value === activityStatus
      })
      if (result.length === 1) {
        return result[0].text
      } else {
        return '未知'
      }
    },
    handleTabClick (tab) {
      if (tab.name === 'merchantDetails') {
        if (this.isFirstClicked) { // 点击过了的tab页 就不在拉取数据
          return
        }
        this.getMerchantDetails()
        this.isFirstClicked = true
      } else if (tab.name === 'bindCardRecords') {
        if (this.isThirdClicked) {
          return
        }
        this.queryBindCardHistory()
        this.isThirdClicked = true
      } else if (tab.name === 'openCardInfo') {
        if (this.isSecondClicked) {
          return
        }
        this.queryOpenCardInfo()
        this.isSecondClicked = true
      } else {
        if (this.isForthClicked) {
          return
        }
        this.queryOperationRecords()
        this.isForthClicked = true
      }
    },
    getBankByActivityId () { // 获取银行网点
      this.$axios.post(this.$api.queryBankByMerchantId, {
        activityId: this.$route.query.activityId
      }).then(res => {
        if (res.respCode === '0') {
          this.bankList = res.data
        }
      })
    },
    handleBankChange (value) { // 银行网点下拉选项改变
      this.$set(this.openCardInfoForm, 'managerId', '')
      if (!value) {
        this.managerList = []
        this.$set(this.openCardInfoForm, 'cardBankNewId', '')
        return
      }
      this.$axios.post(this.$api.queryManager, {
        newCode: value
      }).then(res => {
        if (res.respCode === '0') {
          this.managerList = res.data
        }
      })
    },
    getMerchantDetails () { // 查看商户详情
      const params = { id: this.$route.query.id }
      this.$axios.get(this.$api.queryMerchantDetails, { params }).then(res => {
        if (res.respCode === '0') {
          this.merchantDetailsForm = res.data
        }
      })
    },
    queryOpenCardInfo () { // 查看开卡信息
      const params = { id: this.$route.query.id }
      this.$axios.get(this.$api.queryOpenCardInfo, { params }).then(res => {
        if (res.respCode === '0') {
          const bankCode = res.data.cardBankNewId
          this.handleBankChange(bankCode)
          this.openCardInfoForm = res.data
        }
      })
    },
    queryBindCardHistory () { // 查看绑卡记录
      const params = {
        merchantId: this.$route.query.merchantId,
        activityId: this.$route.query.activityId,
        ...this.bindPagination
      }
      this.$axios.post(this.$api.queryBindHistory, params).then(res => {
        if (res.respCode === '0') {
          this.bindHistoryData = res.data.historyList
          this.bindPagination.total = res.data.count
        } else {
          this.bindHistoryData = []
          this.bindPagination.total = 0
        }
      })
    },
    queryOperationRecords () { // 查看操作记录
      const params = { id: this.$route.query.id }
      this.$axios.post(this.$api.queryOperationRecords, params).then(res => {
        if (res.respCode === '0') {
          this.operateRecordsData = res.data
          this.operatePagination.total = res.data.length || 0
          this.setRecordsDataByPage()
        } else {
          this.operateRecordsData = []
          this.operatePagination.total = 0
          this.operateRecordsPageData = []
        }
      })
    },
    setRecordsDataByPage () { // 操作记录前端分页
      const begin = (this.operatePagination.pageNo - 1) * this.operatePagination.pageSize
      const end = this.operatePagination.pageSize * this.operatePagination.pageNo
      this.operateRecordsPageData = this.operateRecordsData.slice(begin, end)
    },
    updateMerchantInfo () { // 修改商户资料
      const params = { ...this.merchantDetailsForm, id: this.$route.query.id }
      this.$axios.post(this.$api.editMerchantInfo, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '资料修改成功'
          })
        }
      })
    },
    updateOpenCardInfo () { // 修改开卡信息
      const params = {
        ...this.openCardInfoForm,
        id: this.$route.query.id
      }
      this.$axios.post(this.$api.updateOpenCardInfo, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '开卡信息修改成功'
          })
        }
      })
    },
    getAddress (val) {
      this.merchantDetailsForm.address = val
    },
    editMerchantDetails () {
      this.isEditMerchantDetails = true
    },
    editOpenCardInfo () {
      this.isEditOpenCardInfo = true
    },
    getBindRecordList () {
      this.queryBindCardHistory()
    },
    confirmUpdateOpenCard () {
      this.updateOpenCardInfo()
    },
    confirmUpdateMerchantDetails () {
      let detailsFormValid = true
      this.$refs.merchantDetailsForm.validate(valid => {
        if (!valid) {
          detailsFormValid = false
        }
      })
      this.$refs.addressForm.$refs.form.validate(addressValid => {
        if (!addressValid) detailsFormValid = false
      })
      if (detailsFormValid) {
        this.updateMerchantInfo()
      }
    }
  }
}
</script>
<style lang="css" scoped>
.title-bold{
  font-size:18px;
  font-weight:bold;
  margin:15px 0
}
.form-input{
  width:376px;
}
</style>
